import type { FaireProductEntity } from "../../entity_types/product";

export const p_hejs2v3xhp: FaireProductEntity = {
  token: "p_hejs2v3xhp",
  type: "product",
  name: "Red Ribbon Candy Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/10884a7ad4c778b2c5f831a1c424ceec3f60fcc59ffa7529551e39fba0d25a82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/118c3d3ff177f2d16cea4bf60ccb0fbf5a84e1825435b8c823cb7afab1dac14e.jpeg",
    "https://cdn.faire.com/fastly/b0d30d3f1c5ba3224ce3ad99ff1c5090374707e459d01f832af3c83e64e1cbc4.jpeg",
    "https://cdn.faire.com/fastly/d6ad8fe3d2c44aba0e0cf4d9e1594e6a1afded3702d59fea87936f367580f607.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:34.180Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
